export const DEFAULT_THEME_KEY = 'mobile_theme_1'
